import type { LoadingContext } from "@/hooks/global-state/loadingContext";

/**
 * ローディング状態を管理するデコレータ
 */
export async function loadingDecorator<T>(
  fetch: () => T,
  dispatch: LoadingContext["setIsLoading"],
) {
  dispatch(true);
  try {
    return await fetch();
  } finally {
    // reject 時にも必ず false へ戻す
    // 呼び出し元コンポーネントが unmount された後に reject すると他に false へ戻す経路がなく、グローバルな Loading overlay が永久に表示されたままになる
    dispatch(false);
  }
}
